<template>
    <div v-show="visible">
        <el-dialog title="导入成绩" :close-on-click-modal="false" 
            element-loading-background = "rgba(255, 255,255,0.7)"
            :element-loading-text = "loadingText"
            v-loading="loading" 
            :visible.sync="visible" :before-close="dialogClose" width="710px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                <el-row>
                    <el-col :span="11">
                        <el-form-item   prop="title" label="考试名称">
                            <el-input v-model="form.title" maxlength="50" placeholder="如：三年级二班下学期期中考试" style="width:200px;"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="13">
                        <el-form-item   prop="classId" label="考试班级">
                            <el-cascader style="width:250px;"
                                :options="classes"
                                v-model="form.classId"
                                :props="props"
                                collapse-tags
                                clearable></el-cascader>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="11">
                        <el-form-item  prop="examTime" label="考试时间">
                            <el-date-picker
                                style="width:200px;"
                                v-model="form.examTime"
                                type="date"
                                placeholder="考试时间"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>

                    <el-col :span="13" style="padding-left: 33px;">
                        <el-checkbox  v-model="form.showAvgScoreSwitch"><span style="font-size: 12px;">勾选此选项，展示每科成绩的平均分。</span></el-checkbox>                       
                    </el-col>
                </el-row>

                <el-form-item v-if="showScore" prop="" label="查看成绩">
                    <el-button type="success" @click="setLook">查看导入成绩</el-button>
                    <el-button type="danger" @click="showScore=false">删除导入成绩</el-button>
                </el-form-item>

                <el-form-item  prop="" label="上传成绩">
                    <el-upload
                        v-if="!showScore"
                        class="upload-demo"
                        :action="uploadUrl"
                        accept=".xlsx, .xls"
                        :show-file-list="false"
                        :auto-upload="true"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload">
                        <el-button size="small" type="primary">点击上传成绩表格</el-button>
                        <div slot="tip" class="el-upload__tip" style="font-size:12px;color:#BBBBBB">
                            &nbsp;&nbsp;&nbsp;&nbsp;点击“下载模板”按钮，根据模板格式填写成绩信息，然后再进行点击上传，注意点如下：<br/>
                            1、下载的Excel模板中自动生成班级学生、身份证、科目名称，请勿修改。<br/>
                            2、请根据模板中的对应科目，填充考试成绩后，再导入到后台。<br/>
                        </div>
                    </el-upload> 
                    <el-button v-if="!showScore" size="small" type="info" @click="downLoad">下载模板</el-button>
                </el-form-item>
                
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveConfirm(1)">提交成绩</el-button>
                <el-button type="danger" @click="saveConfirm(2)">提交成绩且通知家长</el-button>
            </span>    
        </el-dialog>

         <!-- 查看成绩弹出框 -->
        <div v-if="addVisible">
            <lookScore ref="lookScore"></lookScore>
        </div>
    </div>
</template>
       
<script>
    import http from '../../../common/http'; 
    import {banBackSpace} from '../../../common/preventBackspace';// backspace退格
    import lookScore from './LookScore.vue';
    import axios from 'axios';
    import { Base64 } from 'js-base64'

    export default {
        data(){
            return{
                addVisible:false,
                visible: false,
                showScore:false,
                props: {checkStrictly: true},
                form:{
                    deptId:"",
                    title:"",
                    classId:"",
                    examTime:"",
                    showAvgScoreSwitch:true,
                },
                rules: {
                    title: [
                        { required: true, message: '请输入考试名称', trigger: 'blur' }
                    ],
                    classId: [
                        { required: true, message: '请选择考试班级', trigger: 'blur' }
                    ],
                    examTime: [
                        { required: true, message: '请输入考试时间', trigger: 'blur' }
                    ]
                },
                loading:false,
                loadingText:"",
                uploadForm:new FormData(),
                uploadUrl:"",
                classes:[],
                head:[],
                content:[],
                sign:"",
            }
        },
        components: {
            lookScore
        },
        created:function () {
        },
        methods:{
            init(deptId){
                this.visible=true
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields()
                }
                this.showScore=false
                this.classes=[]
                this.head=[]
                this.content=[]
                this.form.deptId=deptId
                this.uploadForm=new FormData()
                this.uploadUrl=this.ImportScoreUrl
                // 初始班级
                this.getClass()
                this.form.showAvgScoreSwitch = true
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            getClass(){
                let url  = this.getDeptCascaderUrl;
                let data = {
                    deptId:this.form.deptId
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status == 200){
                      this.classes = res.data.selects;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            saveConfirm(sign){ // 提交成绩确认
                this.$refs['form'].validate((valid) => {
                    if(valid){
                        this.sign=sign;
                        if(this.sign == 1){
                            this.save();
                        }else{
                            this.$commonFn.showConfirm2("在发送通知前请确认成绩名单是否正确。通知一旦发出后，家长端的钉钉就会震动或者响铃的方式提醒查看, 是否继续?",this.save);
                        }
                    }
                });
            },
            save(){
                if(this.content.length == 0){
                    this.$commonFn.showTip('导入成绩表单不可为空',3);
                    return;
                }

                let url= this.scoreListSaveUrl;
                let data = {
                    deptId:this.form.deptId,
                    title:this.form.title,
                    classId:this.form.classId[this.form.classId.length-1],
                    examTime:this.form.examTime,
                    showAvgScoreSwitch:this.form.showAvgScoreSwitch,
                    head:JSON.stringify(this.head),
                    content:Base64.encode(JSON.stringify(this.content)),
                    sign:this.sign
                };
                // console.log(JSON.stringify(data));
                // return;
                this.loading=true;
                this.loadingText="提交中...";
                this.apiPost(url, data).then((res) => {
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        this.visible=false;
                        this.$parent.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                }, (err) => {
                    console.log(err);
                    this.loading=false;
                });
            },
            handleAvatarSuccess(res, file) {
                //this.imageUrl = URL.createObjectURL(file.raw);
            },
            beforeAvatarUpload(file) {
                let fileType = file.type
                let isLt2M = file.size / 1024 / 1024 < 100
                console.log("文件类型："+fileType+";文件大小："+file.size)
                if(this.$constant.excelFileType.indexOf(fileType) == -1){
                    this.$commonFn.showTip('导入文件只支持.xls与.xlsx', 3)
                    return false
                }

                if (!isLt2M) {
                    this.$commonFn.showTip('文件大小不能超过100MB!', 3)
                    return false
                }
                // console.log(file.size+"；文件："+isLt2M);
                if(this.form.classId.length == 0){
                    this.$commonFn.showTip("请选择考试班级", 3)
                    return;
                }
                // 上传文件
                this.loading=true;
                this.loadingText="正在导入中..."
                let uploadForm=new FormData()
                uploadForm.append('file', file)
                uploadForm.append('classId',this.form.classId[this.form.classId.length-1])
                this.$axios.post(this.uploadUrl, uploadForm).then((res) => {
                    // console.log("文件反馈:"+JSON.stringify(res.data))
                    if(res.data.status == 200){
                        // console.log(res.data.data);
                        this.showScore=true
                        this.$commonFn.showTip(res.data.message,1)
                        console.log("头部："+JSON.stringify(res.data.data.head))
                        console.log("内容："+JSON.stringify(res.data.data.content))
                        this.head=res.data.data.head
                        this.content=res.data.data.content
                    }else{
                        this.$commonFn.showTip(res.data.message, 4,true)
                    }
                    this.loading=false
                }, (err) => {
                    console.log(err)
                    this.loading=false
                    this.$commonFn.showTip("网络繁忙，请稍后重试，响应码("+err.response.status+")", 3)
                });
            },
            downLoad(){
                if(this.form.classId == ''){
                    this.$commonFn.showTip("请选择考试班级，再进行下载模板", 3);
                    return;
                }

                this.loading=true;
                this.loadingText="下载模板中...";

                let url=this.downloadTemplateScoreUrl;
                let param = new URLSearchParams();
                param.append('classId', this.form.classId[this.form.classId.length-1]);
                param.append('deptId', this.form.deptId);
                
                axios({
                    method: "post",
                    url: url,
                    data: param,
                    responseType: "blob"
                }).then(res => {
                    // console.log(decodeURI(res.headers['filename']));
                    const link = document.createElement("a");
                    let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
                    link.style.display = "none";
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute("download", '成绩表单模板.xls');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.loading=false;
                }).catch(error => {
                    console.log(error);
                    this.loading=false;
                });
            },
            setLook(){// 查看成绩
                this.addVisible=true;
                this.$nextTick(() => {
                    this.$refs['lookScore'].init(this.head,this.content);
                })
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
.el-upload--text{
    width: 700;
}
</style>


// WEBPACK FOOTER //
// src/components/page/score/ImportScore.vue